export const languageContent = {
  bn: {
    // Common
    quiz: "কুইজ",
    lesson: "পাঠ",
    level: "স্তর",
    chapter: "অধ্যায়",
    continue: "চালিয়ে যান",
    back: "ফিরে যান",
    next: "পরবর্তী",
    submit: "জমা দিন",
    correct: "সঠিক",
    incorrect: "ভুল",
    explanation: "ব্যাখ্যা",
    question: "প্রশ্ন",
    answer: "উত্তর",
    score: "স্কোর",
    timer: "টাইমার",
    minutes: "মিনিট",
    questions: "প্রশ্ন",
    completed: "সম্পন্ন",
    yourScore: "আপনার স্কোর",
    
    // Home Screen
    learningProgress: "শিক্ষার অগ্রগতি",
    dayStreak: "দিনের স্ট্রিক",
    totalXP: "মোট এক্সপি",
    lessonsDone: "পাঠ সম্পন্ন",
    searchPlaceholder: "পাঠ অনুসন্ধান করুন...",
    featuredLesson: "বৈশিষ্ট্যপূর্ণ পাঠ",
    grammarBoost: "ব্যাকরণ\nবুস্ট",
    wordMastery: "শব্দ\nআয়ত্ত",
    practiceDaily: "নিয়মিত\nঅনুশীলন",
    allLesson: "সব পাঠ",
    
    // Quiz Screen
    quizTitle: "কুইজ",
    questionCounter: "প্রশ্ন",
    of: "এর",
    nextQuestion: "পরবর্তী প্রশ্ন",
    submitAnswer: "উত্তর জমা দিন",
    noQuestions: "এই পাঠের জন্য কোন প্রশ্ন নেই।",
    backToQuizzes: "কুইজে ফিরে যান",
    
    // Quiz Completion
    congratulations: "অভিনন্দন!",
    quizCompleted: "কুইজ সম্পন্ন হয়েছে!",
    yourResult: "আপনার ফলাফল",
    excellent: "চমৎকার!",
    greatJob: "দুর্দান্ত কাজ!",
    wellDone: "ভালো হয়েছে!",
    keepPracticing: "অনুশীলন চালিয়ে যান!",
    
    // Lessons
    lessonProgress: "পাঠের অগ্রগতি",
    locked: "লক করা",
    inProgress: "চলমান",
    
    // Settings
    settings: "সেটিংস",
    language: "ভাষা",
    profile: "প্রোফাইল",
    subscriptionPremium: "Premium সাবস্ক্রিপশন",
    subscriptionPremiumHint: "বিজ্ঞাপন ছাড়া · সব পাঠ আনলক",
    subscriptionActive: "সক্রিয়",
    subscriptionGet: "এখনই নিন",
    logout: "লগ আউট",
    subscriptionsPremiumActive: "প্রিমিয়াম PDF কেনা হয়েছে — আনলক সক্রিয়",
    subscriptionsRestore: "কেনাকাটা পুনরুদ্ধার করুন",
    subscriptionsRestoreHint: "নতুন ডিভাইসে বা পুনইনস্টলের পর ব্যবহার করুন",
    subscriptionsRestoring: "পুনরুদ্ধার হচ্ছে…",
    subscriptionsRestoreOk: "পুনরুদ্ধার সম্পন্ন।",
    subscriptionsRestoreFail: "পুনরুদ্ধার ব্যর্থ।",
    
    // Navigation
    home: "হোম",
    learn: "শিখুন",
    progress: "অগ্রগতি",

    // Ad Unlock
    adUnlockTitle: "পরবর্তী পাঠ আনলক করুন",
    adUnlockDescription: "এই পাঠটি এখনও লক করা আছে। একটি ছোট বিজ্ঞাপন দেখুন এবং বিনামূল্যে আনলক করুন!",
    adUnlockWatchBtn: "বিজ্ঞাপন দেখুন ও আনলক করুন 🎬",
    adUnlockCancelBtn: "বাতিল করুন",
    adUnlockWatching: "বিজ্ঞাপন চলছে...",
    adUnlockClaimBtn: "পুরস্কার নিন ✓",
    adUnlockSuccess: "পাঠ আনলক হয়েছে! 🎉",
    adUnlockAlready: "ইতিমধ্যে আনলক করা হয়েছে",
    adUnlockNote: "আপনি একটি ছোট ভিডিও (প্রায় ১৫–৩০ সেকেন্ড) দেখবেন। সম্পূর্ণ করলে আনলক হবে।",
    adBannerText: "বিজ্ঞাপন"
  },
  
  it: {
    // Common
    quiz: "Quiz",
    lesson: "Lezione",
    level: "Livello",
    chapter: "Capitolo",
    continue: "Continua",
    back: "Indietro",
    next: "Avanti",
    submit: "Invia",
    correct: "Corretto",
    incorrect: "Sbagliato",
    explanation: "Spiegazione",
    question: "Domanda",
    answer: "Risposta",
    score: "Punteggio",
    timer: "Timer",
    minutes: "minuti",
    questions: "domande",
    completed: "completato",
    yourScore: "Il tuo punteggio",
    
    // Home Screen
    learningProgress: "Progresso di Apprendimento",
    dayStreak: "Giorni di Fila",
    totalXP: "XP Totale",
    lessonsDone: "Lezioni Completate",
    searchPlaceholder: "Cerca lezione...",
    featuredLesson: "Lezione in Evidenza",
    grammarBoost: "Boost\nGrammatica",
    wordMastery: "Padronanza\nParole",
    practiceDaily: "Pratica\nGiornaliera",
    allLesson: "Tutte le Lezioni",
    
    // Quiz Screen
    quizTitle: "Quiz",
    questionCounter: "Domanda",
    of: "di",
    nextQuestion: "Prossima Domanda",
    submitAnswer: "Invia Risposta",
    noQuestions: "Nessuna domanda disponibile per questa lezione.",
    backToQuizzes: "Torna ai Quiz",
    
    // Quiz Completion
    congratulations: "Congratulazioni!",
    quizCompleted: "Quiz Completato!",
    yourResult: "Il tuo risultato",
    excellent: "Eccellente!",
    greatJob: "Ottimo lavoro!",
    wellDone: "Ben fatto!",
    keepPracticing: "Continua a esercitarti!",
    
    // Lessons
    lessonProgress: "Progresso Lezione",
    locked: "Bloccato",
    inProgress: "In Corso",
    
    // Settings
    settings: "Impostazioni",
    language: "Lingua",
    profile: "Profilo",
    subscriptionPremium: "Abbonamento Premium",
    subscriptionPremiumHint: "Senza annunci · tutte le lezioni",
    subscriptionActive: "Attivo",
    subscriptionGet: "Abbonati",
    logout: "Disconnetti",
    subscriptionsPremiumActive: "PDF premium acquistato — sblocco attivo",
    subscriptionsRestore: "Ripristina acquisti",
    subscriptionsRestoreHint: "Dopo reinstall o nuovo dispositivo",
    subscriptionsRestoring: "Ripristino…",
    subscriptionsRestoreOk: "Ripristino completato.",
    subscriptionsRestoreFail: "Ripristino non riuscito.",
    
    // Navigation
    home: "Casa",
    learn: "Impara",
    progress: "Progresso",

    // Ad Unlock
    adUnlockTitle: "Sblocca la Prossima Lezione",
    adUnlockDescription: "Questa lezione è ancora bloccata. Guarda un breve annuncio e sbloccala gratuitamente!",
    adUnlockWatchBtn: "Guarda l'annuncio e sblocca 🎬",
    adUnlockCancelBtn: "Annulla",
    adUnlockWatching: "Annuncio in corso...",
    adUnlockClaimBtn: "Ottieni il premio ✓",
    adUnlockSuccess: "Lezione sbloccata! 🎉",
    adUnlockAlready: "Già sbloccata",
    adUnlockNote: "Vedrai un breve video (circa 15–30 sec). Completalo per sbloccare.",
    adBannerText: "Annuncio"
  },
  
  en: {
    // Common
    quiz: "Quiz",
    lesson: "Lesson",
    level: "Level",
    chapter: "Chapter",
    continue: "Continue",
    back: "Back",
    next: "Next",
    submit: "Submit",
    correct: "Correct",
    incorrect: "Incorrect",
    explanation: "Explanation",
    question: "Question",
    answer: "Answer",
    score: "Score",
    timer: "Timer",
    minutes: "minutes",
    questions: "questions",
    completed: "completed",
    yourScore: "Your Score",
    
    // Home Screen
    learningProgress: "Learning Progress",
    dayStreak: "Day Streak",
    totalXP: "Total XP",
    lessonsDone: "Lessons Done",
    searchPlaceholder: "Search Lesson...",
    featuredLesson: "Featured Lesson",
    grammarBoost: "Grammar\nBoost",
    wordMastery: "Word\nMastery",
    practiceDaily: "Practice\nDaily",
    allLesson: "All Lessons",
    
    // Quiz Screen
    quizTitle: "Quiz",
    questionCounter: "Question",
    of: "of",
    nextQuestion: "Next Question",
    submitAnswer: "Submit Answer",
    noQuestions: "No questions available for this lesson.",
    backToQuizzes: "Back to Quizzes",
    
    // Quiz Completion
    congratulations: "Congratulations!",
    quizCompleted: "Quiz Completed!",
    yourResult: "Your Result",
    excellent: "Excellent!",
    greatJob: "Great Job!",
    wellDone: "Well Done!",
    keepPracticing: "Keep Practicing!",
    
    // Lessons
    lessonProgress: "Lesson Progress",
    locked: "Locked",
    inProgress: "In Progress",
    
    // Settings
    settings: "Settings",
    language: "Language",
    profile: "Profile",
    subscriptionPremium: "Premium subscription",
    subscriptionPremiumHint: "No ads · all lessons unlocked",
    subscriptionActive: "Active",
    subscriptionGet: "Get Premium",
    logout: "Logout",
    subscriptionsPremiumActive: "Premium PDF purchased — unlocked",
    subscriptionsRestore: "Restore purchases",
    subscriptionsRestoreHint: "Use after reinstall or on a new device",
    subscriptionsRestoring: "Restoring…",
    subscriptionsRestoreOk: "Restore complete.",
    subscriptionsRestoreFail: "Restore failed.",
    
    // Navigation
    home: "Home",
    learn: "Learn",
    progress: "Progress",

    // Ad Unlock
    adUnlockTitle: "Unlock Next Lesson",
    adUnlockDescription: "This lesson is still locked. Watch a short ad and unlock it for free!",
    adUnlockWatchBtn: "Watch Ad & Unlock 🎬",
    adUnlockCancelBtn: "Cancel",
    adUnlockWatching: "Ad playing...",
    adUnlockClaimBtn: "Claim Reward ✓",
    adUnlockSuccess: "Lesson Unlocked! 🎉",
    adUnlockAlready: "Already unlocked",
    adUnlockNote: "You'll see a short video (about 15–30 sec). Complete it to unlock.",
    adBannerText: "Advertisement"
  }
};

export type Language = keyof typeof languageContent;
